import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'add-document-dialog',
  templateUrl: './add-document-dialog.component.html',
  styleUrls: ['./add-document-dialog.component.scss']
})
export class AddDocumentDialogComponent implements OnInit {

  documentForm!: FormGroup;

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddDocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log(this.data)
    this.createDocumentForm()
  }

  createDocumentForm() {
    this.documentForm = this.fb.group({
      name: [null, Validators.required],
      docStereoTypeId: [this.data.docStereoTypeId]
    });
  }

  addDocument() {
    if (this.documentForm.valid) {
      this.dialogRef.close(this.documentForm.value);
    }
  }
}
